import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

export type ClaimBenefitLocs = 'CPClaimBenefitButton' | 'CPClaimBenefitNoticeChangesSaved';
export const cpClaimBenefitLocs: LocDefs<ClaimBenefitLocs> = {
	CPClaimBenefitButton: {
		defaultValue: 'Claim Benefit',
		description: 'Button to claim benefit',
		displayPath: `Benefits|Program|Button|Claim Benefit`,
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Button.ClaimBenefit',
		portal: 'CP' as LocPortal,
	},
	CPClaimBenefitNoticeChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Notice for changes saved',
		displayPath: `Benefits|Program|Notification Message|Changes Saved`,
		displayType: 'Notification',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.NotificationMessage.ChangesSaved',
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<ClaimBenefitLocs>(cpClaimBenefitLocs);
